<div [formGroup]="formGroup">
    <sc-checkbox-field formControlName="pickupTruckEnabled"
        [label]="'pickup truck' | translate:['tmc-yard.entity.transport.masterdata.pickupTruckEnabled', translationService.language]"></sc-checkbox-field>
    <ng-container *ngIf="transport.masterdata.pickupTruckEnabled">
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <sc-string-field formControlName="numberplate"
            [label]="'numberplate' | translate:['tmc-yard.entity.transport.masterdata.pickupTruckNumberPlate', translationService.language]"></sc-string-field>
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <sc-date-time-field formControlName="date"
        [label]="'time' | translate:['tmc-yard.entity.transport.masterdata.pickupTruckTime', translationService.language]"></sc-date-time-field>
    </ng-container>
</div>
